import React, { useEffect } from 'react'
import { MyProfilePageProps } from './MyProfilePage.types'
import { User } from 'utilities'
import { USER_PROFILE_STORE } from 'store'
import { inject } from 'mobx-react'
import { UserProfilePageBody } from '../UserProfilePageBody'

const MyProfilePageComponent = (props: MyProfilePageProps) => {
  const {
    // className,
    // style,
    [USER_PROFILE_STORE]: {
      setUser,
      clearStore
    }
  } = props

  useEffect(() => {
    setUser(User.getDetails())
    return clearStore
  }, [setUser, clearStore])

  return (
    <UserProfilePageBody />
  )
}

const MyProfilePage = inject(
  USER_PROFILE_STORE
)(MyProfilePageComponent)
export { MyProfilePage }
